import { useEffect, useState } from "react";
import { inventoryActions } from "redux/Ldb/actions";
import { useAppDispatch, useAppSelector } from "../storeHooks";

const useBulkPinInventory = () => {
    const dispatch = useAppDispatch();
    const [inventoryIds, setInventoryIds] = useState<string[]>([]);
    const [isPinning, setIsPinning] = useState<boolean>(false);

    const { bulkPinningInventory, bulkPinInventorySuccess, bulkPinInventoryFailure } =
        useAppSelector((state) => state.inventory);

    const handleBulkPin = (ids: string[]) => {
        if (ids.length > 0) {
            setInventoryIds(ids);
            setIsPinning(true);
            dispatch(inventoryActions.bulkPinInventory({ inventoryIds: ids }));
        }
    };

    useEffect(() => {
        if (bulkPinInventorySuccess && isPinning) {
            setIsPinning(false);
            setInventoryIds([]);
        }
    }, [bulkPinInventorySuccess, isPinning]);

    useEffect(() => {
        if (bulkPinInventoryFailure && isPinning) {
            setIsPinning(false);
        }
    }, [bulkPinInventoryFailure, isPinning]);

    return {
        isPinning: bulkPinningInventory || isPinning,
        error: bulkPinInventoryFailure,
        success: bulkPinInventorySuccess,
        handleBulkPin,
        inventoryIds,
    };
};

export default useBulkPinInventory;
